import React from "react";
import { connect } from "react-redux";

import Loading from "../../components/loading";
import { autoLogin } from "../../actions/session";

class Demo extends React.Component {

    _getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
  }

  componentDidMount() {
    this.props.autoLogin(this._getUrlVars()["auth_token"], () => { this._success()}, () => console.log("autologin ko"))
  }

  _success(){
    sessionStorage.setItem("authentication_token", this.props.authentication_token);
    window.location.href = "/pro";
  }
  render() {
    return  <Loading />;
  }
}
function mapStateToProps(state) {
  return {
    authentication_token: state.session.authentication_token,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    autoLogin: (authentication_token, success, error) => dispatch(autoLogin(authentication_token, success, error)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Demo);
